import gql from 'graphql-tag'
import { ISpaceType } from '@api/types'
import { SpaceTypeFragment } from '@api/fragments'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        types: { spaceType: ISpaceType[] }
      }
    }
  }
}

export default function spaceTypes(): Promise<ISpaceType[]> {
  return client.gql.query({ query: spaceTypeQuery }).then(
    ({
      data: {
        viewer: {
          company: {
            types: { spaceType },
          },
        },
      },
    }: Payload) => spaceType
  )
}

export const spaceTypeQuery = gql`
  query spaceTypes {
    viewer {
      company {
        types {
          spaceType {
            ...SpaceTypeFragment
          }
        }
      }
    }
  }
  ${SpaceTypeFragment}
`
